<template>
  <div>
    <el-form :model="form" ref="form" size="small" label-width="160px">
      <el-form-item v-for="(item, index) in form.itemList" :key="index"
        :label="item.title + '：'"
        :prop="'itemList.' + index + '.defaultValue'"
        :rules="{
          required: item.ismust, message: '内容不能为空', trigger: 'blur,change'
        }"
      >
        <!-- 1单行文本 -->
        <el-input v-model="item.defaultValue" :placeholder="item.description"  v-if="item.type === 1"></el-input>
        <!-- <span v-show="item.validate && item.type === 1">请根据规则填写</span> -->
        <!-- 2多行文本 -->
        <el-input v-model="item.defaultValue"  type="textarea" v-if="item.type === 2" row="4" :placeholder="item.description"></el-input>
        <!-- 3数字 -->
        <el-input-number v-model="item.defaultValue" controls-position="right" :min="0" v-if="item.type === 3" :placeholder="item.description" :controls="false" class="customForm"></el-input-number>
        <!-- 4日期 -->
        <el-date-picker v-model="item.defaultValue" placeholder="选择日期" type="date" value-format="yyyy-MM-dd" v-if="item.type === 4"></el-date-picker>
        <!-- 5单选 -->
        <el-select v-model="item.defaultValue" v-if="item.type === 5" :placeholder="item.description">
          <el-option v-for="(item2, index2) in item.options" :key="index2" :value="item2"></el-option>
        </el-select>
        <!-- 6多选 -->
        <el-checkbox-group v-model="item.defaultValue" v-if="item.type === 6">
          <el-checkbox :label="item2" v-for="(item2,index2) in item.options" :key="index2">{{ item2 }}</el-checkbox>
        </el-checkbox-group>
        <!-- 7图片 -->
        <div v-if="item.type === 7">
          <el-upload
            class="avatar-uploader" name='file' :multiple='true'
            action="http://up-z2.qiniup.com/" :data='{ token: qiniuConfig.token }'
            :on-success='uploadSuccess' :limit='parseFloat(item.defaultValue) ? parseFloat(item.defaultValue) : 3'
            :on-preview="handlePictureCardPreview"
            :on-remove="handleRemove"
            :before-upload="beforeUpload"
            list-type="picture-card"
            accept="image/gif, image/jpeg, image/png"
            @click.native="changeImageItemId(item.itemId)"
          >
            <i class="el-icon-plus"></i>
            <div slot="tip">图片上传限数：{{ parseFloat(item.defaultValue) ? parseFloat(item.defaultValue) : 3 }}</div>
          <!-- <img :src="dialogImageUrl" class="avatar"> -->
          </el-upload>
          <el-dialog :visible.sync="dialogVisible">
            <img width="100%" :src="dialogImageUrl" alt="">
          </el-dialog>
        </div>
        <!-- 8说明文字 -->
        <p v-if="item.type === 8">{{ item.defaultValue }}</p>
      </el-form-item>
      <el-form-item align="center" label-width="0">
        <!-- <el-button type="primary" @click="submitForm('form')" size="">提 交</el-button> -->
        <!-- <div class="myButton button" @click="submitForm('form')">{{ form.buttonName }}</div> -->
        <el-button size="medium" @click="submitForm('form')" type="primary">{{ form.buttonName ? form.buttonName : '提 交' }}</el-button>
      </el-form-item>
    </el-form>

    <!-- 弹窗登录 -->
    <MaskLogin v-show='showLogin' @close='closeSubmit'></MaskLogin>
    <!-- 消息弹框 -->
    <SubmitSuccess v-if='submitSuccessFlag' @close='submitSuccessFlag = false' class='submit-success' :tipsMsg="tipsMsg"></SubmitSuccess>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import deepcopy from '@/utils/deepcopy';
import { jsTimestampFilter } from '@/utils/filters.js';

export default {
  data() {
    return {
      submitSuccessFlag: false,
      showLogin: false,
      tipsMsg: '',
      form: {},
      dialogImageUrl: '',
      dialogVisible: false,
      qiniuConfig: {},
      picArr: [], // 待上传图片列表。结构：itemId: ['imgUrl', ...], ...
      currentImageItemId: 0, // 可能存在多个上传图片控件
    }
  },
  methods: {
    initFormData() {
      this.form.itemList.forEach((val, i) => {
        val.validate = false;
        if(val.title=="联系人") {
          val.defaultValue = this.user.realName || this.user.userNick;
        }
        if(val.title=="联系电话" || val.title=="联系号码" || val.title=="联系方式") {
          val.defaultValue = this.user.userMobile;
        }
        if(val.title=="公司名称" || val.title=="企业名称") {
          if(this.user.bindCorpInfo && this.user.bindCorpInfo.corpName){
            val.defaultValue = this.user.bindCorpInfo.corpName
          }
        }
        if(val.title=="地址") {
          if(this.user.bindCorpInfo && this.user.bindCorpInfo.corpAddress){
            val.defaultValue = this.user.bindCorpInfo.corpAddress
          } else if(this.user.userCardInfo && this.user.userCardInfo.address) {
            val.defaultValue = this.user.userCardInfo.address
          }
        }
        if (val.type == 5 || val.type == 6) {
          val.options = typeof val.options == 'string' ? val.options.split(',') : val.options;
        }
        if (val.type === 4) {
          val.defaultValue = jsTimestampFilter(new Date().getTime());
        } else if(val.type === 6) {
          val.defaultValue = [];
        } else if (val.type === 7) {
          val.defaultValue = val.defaultValue ? val.defaultValue : 9;
        }
      })
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (!this.token) {
            this.showLogin = true;
            return false;
          }

          // 正则验证
          // var regFlag = false;

          // for (let i = 0; i < this.form.itemList.length; i++) {
          //   if (this.form.itemList[i].regularExpres) {
          //     if (!new RegExp(this.form.itemList[i].regularExpres).test(this.form.itemList[i].defaultValue)) {
          //       this.$message.warning(this.form.itemList[i].title + ':' + this.form.itemList[i].description);
          //       regFlag = true;
          //       break;
          //     }
          //   }
          // }
          // if (regFlag) {
          //   return;
          // }
          // 正则验证结束

          // const images = [];
          let flag = false;
          // this.picArr.forEach((val) => {
          //   images.push(`${this.qiniuConfig.domain}/${val.response.key}`);
          // });
          // const Form = deepcopy(this.form);
          const Form = this.form;
          const content = [];
          Form.itemList.forEach((val) => {
            if (val.type === 6) {  // 处理多选
              val.defaultValue = val.defaultValue ? val.defaultValue.toString() : '';
            } else if (val.type === 7) {  // 处理图片
              const images = this.picArr[val.itemId]
              if (val.ismust && (images == undefined || images.length === 0)) {
                flag = true;
                this.submitSuccessFlag = true;
                this.tipsMsg = '请上传图片';
                return;
              }
              if (images && images.length) {
                val.defaultValue = images.toString();
              } else {
                val.defaultValue = '';
              }
            } else if (val.type === 3) {  // 处理数字
              val.defaultValue = val.defaultValue + '';
            }

              content.push({
                itemId: val.itemId,
                title: val.title,
                type: val.type,
                value: val.defaultValue,
              });

          });


          if (!flag) {  // 无错误则提交
            this.$emit('finishForm', content);
          }
        } else {
          this.submitSuccessFlag = true;
          this.tipsMsg = '请完整填写信息';
          return false;
        }
      });
    },
    resetForm() {
      this.$refs.form.resetFields();
    },
    beforeUpload(file) {
      if (!this.token) {
        this.showLogin = true;
        return false;
      }
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/gif' || file.type === 'image/png';
      const isLt2M = file.size / 1024 / 1024 < 5;

      if (!isJPG) {
        this.$message.error('上传头像图片只能是 jpg,gif,png 格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 5MB!');
      }
      return isJPG && isLt2M;
    },
    closeSubmit() {
      this.showLogin = false;
      if (this.token) {
        this.getUploadToken();
      }
    },
    getUploadToken() {
      this.$http.post(`${this.URL_PREFIX}/app/get/qiniu/bucket/token`, {}, {
        headers: { token: this.token },
      }).then((response) => {
        const res = response.data;
        if (res.resCode === '10000') {
          this.qiniuConfig = res.resData;
        }
      });
    },
      // 图像上传成功
    uploadSuccess(res, file, fileList) {
      if(this.picArr[this.currentImageItemId] == undefined) this.$set(this.picArr, this.currentImageItemId, [])
      this.dialogImageUrl = `${this.qiniuConfig.domain}/${res.key}`;
      this.picArr[this.currentImageItemId].push(this.dialogImageUrl);
    },
    handleRemove(file, fileList) {
      this.picArr[this.currentImageItemId] = [];
      fileList.forEach((v, i)=>{
        this.picArr[this.currentImageItemId].push(`${this.qiniuConfig.domain}/${v.response.key}`)
      })
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    changeImageItemId(itemId){
      this.currentImageItemId = itemId
    },
  },
  props: {
    formObj: {
      type: Object,
      default() {
        return {}
      },
    },
  },
  watch: {
    formObj(val, oldVal) {
      this.form = deepcopy(val);
      this.initFormData();
    }
  },
  created() {
    this.form = deepcopy(this.formObj);
    this.initFormData();
  },
  mounted() {
    this.getUploadToken();
  },
  computed: {
    ...mapGetters(['token','user']),
  },
}
</script>

<style lang="scss" scoped>
.el-form {
  border-radius: 6px;
}
.el-form-item {
  margin-bottom: 10px;
  padding-bottom: 10px;
  .el-input, .el-select, .el-textarea  {
    width: 100%;
  }
  .el-input-number,
  .el-date-editor
  {
    width: 200px;
  }

  .avatar-uploader {
    border-bottom: 1px dashed #ccc;
  }
  .el-button {
    margin-top: 20px;
  }
}

.submit-success {
  left: 50%;
  bottom: 50%;
  transform: translate(-50%, 50%);
}
</style>




// WEBPACK FOOTER //
// src/components/CustomForm.vue